var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "breadcrumbBlock text-center w-100" }, [
    _c(
      "ul",
      {
        staticClass: "breadcrumb m-0 d-inline-block",
        attrs: { "data-simplebar": "" },
      },
      _vm._l(_vm.list, function (item, i) {
        return _c(
          "li",
          {
            key: i,
            ref: "items",
            refInFor: true,
            class: { active: item === _vm.current },
          },
          [_vm._t("default", null, { item: item })],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }